import LinksListPresenter from "../../../links-list/presenter/links-list";

import {
  createElement,
  replace
} from "../../../render/render.js";

export default class LinksList extends LinksListPresenter {
  constructor(listElement, changeFilter) {
    super(listElement);

    this._changeFilter = changeFilter;

    this._handleChangeFilterLoad = this._handleChangeFilterLoad.bind(this);
  }

  init(afterLoad = false) {
    if (afterLoad === false) {
      super.init();
    } else {
      this._handleWindowLoad();
    }

    this._changeFilter.addLoadObserver(this._handleChangeFilterLoad);
  }

  reInit(template) {
    const newElement = createElement(template);
    replace(newElement, this._listElement);

    this._listElement = newElement;
    this._listView = null;
    this._itemsViews = [];
    this._buttonView = null;

    this._model = null;

    window.removeEventListener(`resize`, this._handleWindowResizeDebounced);

    this._handleWindowLoad();
  }

  _handleChangeFilterLoad(data) {
    if (!data.seo_filter) {
      return;
    }

    // Changing links list.
    if (data.seo_filter.links_list) {
      this.reInit(data.seo_filter.links_list);
    }
  }
}
